import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import Iframe from "react-iframe";

const TnLocalElectionResult = () => {
  const [report, setReport] = useState(0);
  useEffect(
    () => {
      const timer = setInterval(() => {
        setReport(report + 1);
      }, 72000);
      return () => clearInterval(timer);
    },
    [report]
  );

  return (
    <div className={`${styles["florish-chart"]}`}>
      <Iframe
        url="https://flo.uri.sh/visualisation/8729876/embed"
        width="100%"
        frameBorder="0"
        className={styles["chart-iframe"]}
        key={report}
      />
    </div>
  );
};

TnLocalElectionResult.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
  showTitle: PropTypes.bool
};

export default TnLocalElectionResult;
